import mitt, { Emitter } from 'mitt'
import { ToastContainerProps, ToastItem } from './toast.types'
export type ToastEvent = {
  increment: ToastItem
  decrement: string
  globalProps: ToastContainerProps
}
export const toastEmitter: Emitter<ToastEvent> = mitt<ToastEvent>()
